import React from 'react';

import {
    Button,
} from '@material-ui/core';

import { withStyles } from '@material-ui/core/styles';

const PlainLink = withStyles(theme => ({
    root: {
        margin: '0px !important',
        minWidth: '0px',
        padding : "0px",
        justifyContent : "normal",
    }
}))(props => <Button className="m-2 text-primary px-0" {...props} />);

export default PlainLink;